import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  withStyles
} from "@material-ui/core";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { capitalizeFirstLetter } from "../../../../../../utils/CapitalizeFirstLetter";
import { ActionsMenu } from "../../../../components/ActionsMenu";
import styles from "./tableOwnDeliveryCounter.module.scss";


const TableOwnDeliveryCounter = (
  {
    items,
    setIsLoading
  }
) => {


  const StyledTableHead = withStyles(theme => ({
    root: {
      backgroundColor: "#DEF6E7"
    }
  }))(TableHead);

  const StyledTableCell = withStyles(theme => ({
    head: {
      color: "#333333",
      textAlign: "center",
      fontFamily: "Mulish",
      fontWeight: 700,
      fontSize: 14,
      padding: "13.5px 0 10.5px"
    },
    body: {
      textAlign: "center",
      fontSize: 12,
      padding: 16,
      fontWeight: 500,
      paddingLeft: 18,
      paddingRight: 18,
      fontFamily: "Mulish",
      borderBottom: 0
    }
  }))(TableCell);

  const StyledTableRow = withStyles(theme => ({
    root: {
      "&:last-child()": {
        borderBottom: "0"
      }
    }
  }))(TableRow);

  const [itemsTable, setItemsTable] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [district, setDistrict] = useState(null);

  const countItemsByDistrictWithTotal = (payload) => {
    const districts = [];
    let totalItems = 0;

    Object.entries(payload).forEach(([key, value]) => {
      const itemCount = value?.shippings?.length;
      const items = value?.shippings;
      totalItems += itemCount;

      districts.push({
        district: key,
        itemCount: itemCount,
        items: items
      });
    });

    districts.sort((a, b) => a?.district.localeCompare(b?.district));

    return { districts, totalItems };
  };

  useEffect(() => {
    setItemsTable(countItemsByDistrictWithTotal(items))
  }, [items])

  const renderTableWithPackageInfo = useCallback(
    district => {
      return (
        <Table
          size="small"
          style={{
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.10)",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px"
          }}
          aria-label="Tabela com informações dos pacotes."
        >
          <StyledTableHead>
            <TableRow>
              <StyledTableCell
                style={{
                  borderTopLeftRadius: "10px"
                }}
              >
                {"Identificação"}
              </StyledTableCell>
              <StyledTableCell>Data de Criação</StyledTableCell>
              <StyledTableCell>Validado em</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell
                style={{
                  borderTopRightRadius: "10px"
                }}
              >
                Ações
              </StyledTableCell>
            </TableRow>
          </StyledTableHead>
          <TableBody
            style={{
              maxHeight: 450,
              overflow: "auto"
            }}
          >
            {district?.items?.map(row => (
              <StyledTableRow
                key={row?.shipping?.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                style={{
                  textAlign: "center"
                }}
              >
                <StyledTableCell component="th" scope="row">
                  <Link
                    to={`/detalhes-objeto/${row?.shipping?.id}`}
                    style={{
                      borderBottom: "1px solid #409E6A",
                      color: "#409E6A",
                      fontWeight: 700
                    }}
                  >
                    {row?.shipping?.sro}
                  </Link>
                </StyledTableCell>

                <StyledTableCell align="center">
                  {moment(row?.shipping?.created_at).format("DD/MM/YYYY")}
                </StyledTableCell>


                <StyledTableCell align="center">
                  {moment(row?.sentDate).format("DD/MM/YYYY")}
                </StyledTableCell>

                <StyledTableCell align="center">
                  <span className={`${styles.statusCollect} ${styles.going}`}>
                    {"Objeto Expedido"}
                  </span>
                </StyledTableCell>

                <StyledTableCell
                  align="center"
                  style={{
                    weight: "120px"
                  }}
                >
                  <ActionsMenu
                    shipping={row?.shipping}
                    setLoading={setIsLoading}
                  />
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      );
    },
    []
  );

  const modalDetailsOfDistrict = district => {
    const body = renderTableWithPackageInfo(district);

    return (
      <Modal
        size="xl"
        show={true}
        centered
        aria-labelledby="contained-modal-title-vcenter"
        onHide={() => {
          setDistrict(null);
          setShowModal(false);
        }}
        className={`${styles.modal}`}
      >
        <div className={`${styles.modalContent}`}>
          <Modal.Header style={{ borderBottom: 0, padding: "32px 32px 0" }}>
            <Modal.Title
              style={{
                width: "100%",
                color: "#409E6A",
                fontFamily: "Mulish",
                fontSize: 24,
                fontWeight: "700",
                borderBottom: "1px solid #C0C0C0"
              }}
            >
              Detalhes - {capitalizeFirstLetter(district?.district)}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ padding: "24px 32px", overflowX: "auto", overflowY: "auto", height: "70%" }}>
            <div
              id={"scrollContainerShippings"}
              className={`${styles.modalBody}`}
            >
              {body}
            </div>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: 0, paddingBottom: 32 }}>
            <button
              onClick={() => {
                setShowModal(false);
              }}
              className={styles.buttonModal}
            >
              Fechar
            </button>
          </Modal.Footer>
        </div>
      </Modal>
    );
  };


  return (
    <>
      {!!showModal && !!district && modalDetailsOfDistrict(district)}

      <table className={styles.tableStatus}>
        <thead>
          <tr>
            <th>Bairro</th>
            <th>Quantidade</th>
          </tr>
        </thead>
        <tbody>
          {itemsTable?.districts
            ?.map(item => {
              return (
                <tr
                  key={item.district}
                  className={styles.hoverSign}
                  onClick={() => {
                    setShowModal(true)
                    setDistrict(item)
                  }}
                >
                  <td>{capitalizeFirstLetter(item.district)}</td>
                  <td>{item.itemCount}</td>
                </tr>
              );
            })}
        </tbody>
        <tfoot>
          <tr className={styles.hoverSign}        >
            <th>{"Total"}</th>
            <th>{itemsTable?.totalItems}</th>
          </tr>
        </tfoot>
      </table>
    </>
  );
};

export { TableOwnDeliveryCounter };